import { type FormValuesEvents, useFormStore } from "@/widgets/classic-form/form";

const eventsAreExact = (events: FormValuesEvents) =>
    Object.values(events).every((event) => {
        if (!event.instances.length) return true;
        return event.instances.every((instance) => {
            // Instances in range mode are detached from MAT — skip them
            if (instance.isRangeMode) return true;

            const dateIsExact = instance.dateProximity?.year !== null;
            const locationIsExact = instance.locationExactness !== null;
            return dateIsExact && locationIsExact;
        });
    });

export const useEventExactness = () => {
    const isExact = useFormStore((data) => eventsAreExact(data.values.events));
    return isExact;
};
